export const HEIGHT_TIMELINE_HEADER = 50
export const HEIGHT_TIMELINE_TAB = 47
export const HEIGHT_BOTTOM_SHEET_HANDLE = 25
export const HEIGHT_TIMELINE_FILTERS = 68
